import type { Space } from '@cocoonspace/sdk-js/types/space'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { buttonVariants } from '~/components/ui/button'
import { SpaceSectionContent } from '~/domains/spaces/components/space-details/space-section-content'
import { SpacePricesRecurring } from './space-prices-recurring'
import { SpaceSectionTitle } from './space-section-title'

export const SpacePrices = ({
	space,
}: {
	space: Space
}) => {
	const { t } = useTranslation()

	return (
		<SpaceSectionContent id='prices'>
			<SpaceSectionTitle>
				{t('space:sections.prices.title.long')}
			</SpaceSectionTitle>

			<SpacePricesRecurring space={space} />

			<div className='flex flex-col items-center gap-x-8 gap-y-4 lg:flex-row'>
				<div className='w-full lg:w-1/2'>
					<div className='font-bold'>
						{t('space:sections.prices.pricings.quotation.title')}
					</div>

					{t('space:sections.prices.pricings.quotation.body')}
				</div>

				<div className='w-full lg:w-1/2'>
					<Link
						href='https://cocoonspace.typeform.com/to/ekCM8SS9'
						target='_blank'
						className={buttonVariants({
							variant: 'outline',
							className: 'text-center max-md:w-full',
						})}
					>
						{t('space:sections.prices.pricings.quotation.askQuotationBtn')}
					</Link>
				</div>
			</div>
		</SpaceSectionContent>
	)
}
